let productRentalInstance = null;

class ProductRental {
  constructor(isCartPage = false) {
    // Add guest cart key
    this.GUEST_CART_KEY = 'wr-guest-cart';
    
    this.rentalOptions = document.getElementById('rental-options');
    
    this.isCartPage = isCartPage;
    if (!this.rentalOptions && !this.isCartPage) {
      return;
    }

    if (!this.rentalOptions && this.isCartPage) {
    }

    this.injectStyles();

    this.productId = this.rentalOptions.dataset.productId;
    this.variantId = this.rentalOptions.dataset.variantId;
    this.rentalSelect = document.getElementById('rental-period');
    this.rentalPrices = document.getElementById('rental-prices');
    this.addRentalButton = document.getElementById('add-rental-to-cart');

    if (!this.productId || !this.variantId || !this.rentalSelect || !this.rentalPrices || !this.addRentalButton) {
      return;
    }

    this.apiBaseUrl = 'https://wonderent.wonderchef.com/api';
    this.isLoading = false;
    this.allPrices = {};

    this.initializeRental().catch(error => {
      this.showError('Failed to initialize rental system. Please refresh the page and try again.');
    });

    // Initially disable the Add to Rent Cart button
    if (this.addRentalButton) {
        this.addRentalButton.disabled = true;
    }
  }

  async initializeRental() {
    this.initEventListeners();
    if (!this.isCartPage) {
      await this.fetchAllRentalPrices();
    }
  }

  initEventListeners() {
    if (this.rentalSelect) {
      this.rentalSelect.addEventListener('change', this.handleRentalPeriodChange.bind(this));
    } else if (!this.isCartPage) {
    }
    
    if (this.addRentalButton) {
      this.addRentalButton.addEventListener('click', this.handleAddRentalToCart.bind(this));
    } else {
    }
    
    if (!this.isCartPage) {
      document.addEventListener('variant:changed', (event) => {
        this.variantId = event.detail.variant.id;
        this.updateProductInfo(event.detail.variant);
        this.fetchAllRentalPrices();
      });
    }
  }

  updateProductInfo(variant) {
    const priceElement = document.querySelector('.product__price');
    if (priceElement) {
      priceElement.textContent = variant.price;
    }
  }

  handleRentalPeriodChange() {
    const selectedPeriod = this.rentalSelect.value;
    if (selectedPeriod && this.allPrices[selectedPeriod]) {
      const data = this.allPrices[selectedPeriod];
      const isAvailable = data.available_quantity > 0;
      this.addRentalButton.disabled = !isAvailable;
      this.addRentalButton.textContent = isAvailable ? 'Add to Rent Cart' : 'Not Available';
      localStorage.setItem('selectedRentalPeriod', selectedPeriod);
    } else {
      this.addRentalButton.disabled = true;
      this.addRentalButton.textContent = 'Select a rental period';
      localStorage.removeItem('selectedRentalPeriod');
    }
  }

  getCartId() {
    return localStorage.getItem('cartId');
  }

  setCartId(cartId) {
    localStorage.setItem('cartId', cartId);
  }

  isUserLoggedIn() {
    return !!window.wrAuthInstance?.sessionHandler?.getCurrentUser();
  }

  async addToGuestCart(rentalData) {
    try {
      const guestCart = JSON.parse(localStorage.getItem(this.GUEST_CART_KEY) || '{"items":[]}');
      
      const existingItem = guestCart.items.find(item => 
        item.product_id === this.productId &&
        item.variant_id === this.variantId &&
        item.rental_period === rentalData.rental_period
      );

      if (existingItem) {
        existingItem.quantity += 1;
        existingItem.total = existingItem.price * existingItem.quantity;
        existingItem.security_deposit = rentalData.refundable_deposit * existingItem.quantity;
      } else {
        const newItem = {
          id: Date.now(),
          product_id: this.productId,
          variant_id: this.variantId,
          name: rentalData.product_name,
          image_url: document.querySelector('.product__media img')?.src,
          rental_period: rentalData.rental_period,
          quantity: 1,
          price: rentalData.total_rent,
          total: rentalData.total_rent,
          emi: rentalData.emi,
          security_deposit: rentalData.refundable_deposit,
          estimated_delivery_date: rentalData.estimated_delivery_date,
          estimated_return_date: rentalData.estimated_return_date
        };
        guestCart.items.push(newItem);
        localStorage.setItem('lastAddedItem', JSON.stringify(newItem));
      }

      localStorage.setItem(this.GUEST_CART_KEY, JSON.stringify(guestCart));

      if (window.wrAuthInstance?.stateBridge.isAuthenticated()) {
        await window.wrAuthInstance.stateBridge.syncCart();
      }

      window.dispatchEvent(new CustomEvent('cartUpdated'));
      return true;
    } catch (error) {
      return false;
    }
  }

  async handleAddRentalToCart() {
    const selectedPeriod = this.rentalSelect.value;
    const selectedData = this.allPrices[selectedPeriod];

    if (selectedData) {
      try {
        if (this.isUserLoggedIn()) {
          await this.addToRentalCart(selectedData);
        } else {
          const success = await this.addToGuestCart(selectedData);
          if (success) {
            this.updateCartDisplay({ items: JSON.parse(localStorage.getItem(this.GUEST_CART_KEY)).items });
          } else {
            throw new Error('Failed to add to guest cart');
          }
        }
        
        // this.showAddToCartPopup(selectedData);
        document.getElementById('shopify-rent_cart').click();
      } catch (error) {
        this.showError('Unable to add rental to cart. Please try again.');
      }
    } else {
      this.showError('Unable to add rental to cart. Please try again.');
    }
  }

  async apiCall(endpoint, method = 'GET', body = null, includeCartId = false) {
    this.setLoading(true);
    try {
      const headers = new Headers({
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      });

      const options = {
        method,
        headers,
        credentials: 'include',
        mode: 'cors'
      };

      if (body) {
        options.body = JSON.stringify(body);
      }

      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 30000);

      const timestamp = new Date().getTime();
      const urlWithTimestamp = `${this.apiBaseUrl}/${endpoint}${endpoint.includes('?') ? '&' : '?'}_=${timestamp}`;

      const response = await fetch(urlWithTimestamp, { ...options, signal: controller.signal });
      clearTimeout(timeoutId);

      if (!response.ok) {
        const responseText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${responseText}`);
      }

      const jsonResponse = await response.json();
      return jsonResponse;
    } catch (error) {
      if (error.name === 'AbortError') {
        this.showError('The request timed out. Please try again.');
      } else {
        this.showError(`An error occurred. Please try again.`);
      }
      throw error;
    } finally {
      this.setLoading(false);
    }
  }

  async addToRentalCart(rentalData) {
    if (this.isLoading) {
      return;
    }
  
    this.setLoading(true);
  
    const requestBody = {
      product_id: this.productId,
      variant_id: this.variantId,
      rental_period: rentalData.rental_period,
      quantity: 1,
      price: rentalData.total_rent,
    };
  
    try {
      const response = await fetch(`${this.apiBaseUrl}/add-to-rental-cart/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(requestBody),
        credentials: 'include'
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      throw error;
    } finally {
      this.setLoading(false);
    }
  }  
  
  async fetchCart(cartId) {
    try {
      const response = await fetch(`${this.apiBaseUrl}/get-rental-cart/`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'include'
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const cartData = await response.json();
      this.updateCartDisplay(cartData);
    } catch (error) {
      this.showError(`Failed to fetch cart. ${error.message}`);
    }
  }
  
  // Modify updateCartDisplay to handle guest cart
  async updateCartDisplay(cartData) {
    
    if (this.isUserLoggedIn()) {
        try {
            // For logged-in users, always fetch fresh cart data
            const response = await fetch('https://wonderent.wonderchef.com/api/get-rental-cart/', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include'
            });
            
            if (!response.ok) {
                throw new Error('Failed to fetch updated cart');
            }
            
            const freshCartData = await response.json();
            
            window.dispatchEvent(new CustomEvent('cartUpdated', { 
                detail: { cart: freshCartData }
            }));
        } catch (error) {
            console.error('Error updating cart display:', error);
        }
    } else {
        // Guest cart display logic
        const guestCart = JSON.parse(localStorage.getItem(this.GUEST_CART_KEY) || '{"items":[]}');
        window.dispatchEvent(new CustomEvent('cartUpdated', { 
            detail: { cart: { cart_items: guestCart.items } }
        }));
    }
  }
  
    
  async fetchAllRentalPrices() {
    if (this.isCartPage) return;
    const periods = ['1m', '3m', '6m', '9m', '12m'];
    
    // Show skeleton before starting API calls
    this.showSkeleton();
    this.setLoading(true);

    try {
      for (const period of periods) {
        const data = await this.fetchRentalPrice(period);
        if (data) {
          this.allPrices[period] = data;
        }
      }
      this.updatePriceDisplay();
    } catch (error) {
      this.showError('Failed to load rental prices. Please try again later.');
    } finally {
      this.setLoading(false);
    }
  }
    
  async fetchRentalPrice(rentalPeriod, retryCount = 0) {
    const endpoint = `rental-price/?product_id=${this.productId}&variant_id=${this.variantId}&rental_period=${rentalPeriod}`;
    
    try {
      const result = await this.apiCall(endpoint, 'GET', null, false);
      return result.data;
    } catch (error) {
      // Don't retry for 400 errors (disabled periods)
      if (error.status === 400 || error.message?.includes('400')) {
        return null;
      }
      
      // Only retry once for network/timeout issues
      if (retryCount < 1) {
        await new Promise(resolve => setTimeout(resolve, 500)); // Reduced to 500ms
        return this.fetchRentalPrice(rentalPeriod, retryCount + 1);
      }
      
      // After single retry, return null without showing error for disabled periods
      return null;
    }
  }

  updatePriceDisplay() {
    if (!this.rentalPrices || !this.rentalSelect) {
      console.error('Rental prices container or select element not found');
      return;
    }

    this.logoUrl = this.rentalOptions.dataset.logoUrl;

    let html = '<div class="rental-options-wrapper active">';
    html += '<div class="rental-accordion-header" onclick="this.parentElement.classList.toggle(\'active\')">';
    html += `<h3>Rent now with <img src="${this.logoUrl}" alt="WONDERENT" style="height: 24px; vertical-align: bottom;"></h3>`;
    html += '<span class="accordion-icon">&#x25BC;</span>';
    html += '</div>';
    html += '<div class="rental-accordion-content">';
    html += '<div class="rental-period-options">';

    const periods = [
        { months: 1, key: 'm1', label: '1 Month' },
        { months: 3, key: 'm3', label: '3 Months' },
        { months: 6, key: 'm6', label: '6 Months' },
        { months: 9, key: 'm9', label: '9 Months' },
        { months: 12, key: 'm12', label: '12 Months' }
    ];

    let firstPeriodSet = false;
    const enabledPeriods = this.rentalOptions.dataset.enabledPeriods 
        ? JSON.parse(this.rentalOptions.dataset.enabledPeriods) 
        : {};

    periods.forEach(period => {
        // Skip disabled periods entirely
        if (enabledPeriods[period.key] === false) {
            return; // Skip this iteration
        }

        // Only proceed if we have price data for this period
        const data = this.allPrices[`${period.months}m`];
        if (data) {
            const monthlyRate = this.formatMoney(data.emi);
            html += `
                <div class="rental-period-option ${!firstPeriodSet ? 'active' : ''}" data-period="${period.months}m">
                    <div class="rental-period-header">
                        <span>${period.label}</span>
                        <span>${monthlyRate}/mo</span>
                    </div>
                </div>
            `;
            
            if (!firstPeriodSet) {
                this.rentalSelect.value = `${period.months}m`;
                firstPeriodSet = true;
            }
        }
    });

    html += '</div>';

    // Add rental details, quantity selector, and total
    html += '<div class="rental-details-row">';
    html += '<div class="rental-details-left">';
    html += '<div class="selected-rental">Rent: <span id="selected-rental-price"></span></div>';
    html += '<div class="security-deposit">Refundable Deposit: <span id="security-deposit-amount"></span></div>';
    html += '</div>';
    html += '<div class="quantity-selector">';
    html += '<label for="rental-quantity">Quantity:</label>';
    html += '<div class="quantity-input">';
    html += '<button type="button" class="quantity-decrease">-</button>';
    html += '<input type="number" id="rental-quantity" name="rental-quantity" value="1" min="1">';
    html += '<button type="button" class="quantity-increase">+</button>';
    html += '</div>';
    html += '</div>';
    html += '<div class="rental-details-right">';
    html += '<div class="rental-total">TOTAL: <span id="total-rental-amount"></span></div>';
    html += '</div>';
    html += '</div>';

    html += '<div class="rental-bottom-row">';
    
    // Left side - ZIP code
    html += '<div class="rental-bottom-left">';
    html += '<div class="zip-input-group">';
    html += '<input type="text" id="zip-code-input" placeholder="Enter PIN code" maxlength="6" pattern="[0-9]*">';
    html += '<button id="validate-zip-code-button">Check</button>';
    html += '</div>';
    html += '<div id="zip-code-status"></div>';
    html += '</div>';
    
    // Right side - Add to Cart (modified to be disabled and grey by default)
    html += '<div class="rental-bottom-right">';
    html += '<button id="add-rental-to-cart" class="button btn--primary" disabled style="opacity: 0.5; cursor: not-allowed;">ADD TO RENT CART</button>';
    html += '</div>';
    
    html += '</div>'; // Close rental-bottom-row

    html += '<a href="#tab6" class="rental-faqs-link" onclick="ClickTab6()">How rental works?</a>';


    html += '</div>'; // Close rental-accordion-content
    html += '</div>'; // Close rental-options-wrapper

    this.rentalPrices.innerHTML = html;

    // Update event listeners
    this.addRentalButton = document.getElementById('add-rental-to-cart');
    if (this.addRentalButton) {
      this.addRentalButton.addEventListener('click', this.handleAddRentalToCart.bind(this));
    }

    // Add event listeners for quantity buttons
    const quantityInput = document.getElementById('rental-quantity');
    const decreaseBtn = document.querySelector('.quantity-decrease');
    const increaseBtn = document.querySelector('.quantity-increase');

    decreaseBtn.addEventListener('click', () => {
      if (quantityInput.value > 1) {
        quantityInput.value = parseInt(quantityInput.value) - 1;
        this.updateTotalPrice();
      }
    });

    increaseBtn.addEventListener('click', () => {
      quantityInput.value = parseInt(quantityInput.value) + 1;
      this.updateTotalPrice();
    });

    quantityInput.addEventListener('change', () => {
      this.updateTotalPrice();
    });

    // Add event listeners for rental period options
    const rentalPeriodOptions = document.querySelectorAll('.rental-period-option');
    rentalPeriodOptions.forEach(option => {
      option.addEventListener('click', (event) => {
        const selectedPeriod = event.currentTarget.dataset.period;
        this.rentalSelect.value = selectedPeriod;
        this.handleRentalPeriodChange();
        this.updateTotalPrice();
        // Add active class to selected option
        rentalPeriodOptions.forEach(opt => opt.classList.remove('active'));
        event.currentTarget.classList.add('active');
      });
    });

    // Add ZIP code validation event listeners
    const zipCodeInput = document.getElementById('zip-code-input');
    const validateButton = document.getElementById('validate-zip-code-button');
    
    if (zipCodeInput && validateButton) {
        validateButton.addEventListener('click', () => this.validateZipCode());
        zipCodeInput.addEventListener('keyup', (e) => {
            if (e.key === 'Enter') {
                this.validateZipCode();
            }
        });
    }

    // Add number-only input restriction
    zipCodeInput.addEventListener('input', (e) => {
        e.target.value = e.target.value.replace(/[^0-9]/g, '');
    });

    this.handleRentalPeriodChange();
    this.updateTotalPrice();

    // Add this after all event listeners
    const addToCartButton = document.getElementById('add-rental-to-cart');
    if (addToCartButton) {
        // Ensure button starts disabled and grey
        addToCartButton.disabled = true;
        addToCartButton.style.opacity = '0.5';
        addToCartButton.style.cursor = 'not-allowed';
    }
  }

  updateTotalPrice() {
    const quantityInput = document.getElementById('rental-quantity');
    const quantity = parseInt(quantityInput.value);
    const selectedPeriod = this.rentalSelect.value;
    const selectedData = this.allPrices[selectedPeriod];
  
    if (selectedData) {
      const monthlyRent = selectedData.emi;
      const upfrontRent = selectedData.total_rent;
      const totalRent = selectedData.total_price * quantity;
      const refundableDeposit = selectedData.refundable_deposit * quantity;

  
      document.getElementById('selected-rental-price').textContent = this.formatMoney(upfrontRent);
      document.getElementById('security-deposit-amount').textContent = this.formatMoney(refundableDeposit);
      document.getElementById('total-rental-amount').textContent = this.formatMoney(totalRent);    
      const totalPriceElement = document.getElementById('total-rental-amount');
      if (totalPriceElement) {
        totalPriceElement.innerHTML = `${this.formatMoney(totalRent)}/-`;
      }
    }
  }

  setLoading(isLoading) {
    this.isLoading = isLoading;
    if (!this.isCartPage && this.addRentalButton) {
      this.addRentalButton.disabled = isLoading;
      this.addRentalButton.innerHTML = isLoading ? '<span class="loading-spinner"></span> Loading...' : 'ADD TO RENT CART';
    }
    const loadingOverlay = document.getElementById('loading-overlay');
    if (loadingOverlay) {
      loadingOverlay.style.display = isLoading ? 'flex' : 'none';
    }
  }

  showError(message) {
    // Skip showing these specific errors on screen
    if (message.includes('Failed to fetch rental price') || 
        message === 'An error occurred. Please try again.') {
        // Just log to console

        return;
    }

    // Show all other errors as normal

    const errorDiv = document.createElement('div');
    errorDiv.className = 'error-message';
    errorDiv.setAttribute('role', 'alert');
    errorDiv.textContent = message;
    if (this.isCartPage || !this.rentalOptions) {
        document.body.appendChild(errorDiv);
    } else {
        this.rentalOptions.appendChild(errorDiv);
    }
    setTimeout(() => errorDiv.remove(), 50000);
  }

  showMessage(message) {
    const messageDiv = document.createElement('div');
    messageDiv.className = 'success-message';
    messageDiv.setAttribute('role', 'alert');
    messageDiv.textContent = message;
    if (this.isCartPage || !this.rentalOptions) {
      document.body.appendChild(messageDiv);
    } else {
      this.rentalOptions.appendChild(messageDiv);
    }
    setTimeout(() => messageDiv.remove(), 50000);
  }

  formatMoney(amount) {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(amount);
  }

  static initialize() {
    const rentalOptions = document.getElementById('rental-options');
    const isCartPage = window.location.pathname.includes('/rental-cart');
    if (!productRentalInstance) {
      productRentalInstance = new ProductRental(isCartPage);
    }
  }

  injectStyles() {
    const styles = `
        .rental-options-wrapper {
            border: 1px solid #e0e0e0;
            overflow: hidden;
            border-radius: 5px;
            font-family: Arial, sans-serif;
            width: 100%;
            max-width: 100%;
        }

        .rental-period-options {
            display: flex;
            justify-content: space-between;
            gap: 8px;
            margin: 12px 0;
        }

        /* Mobile Styles */
        @media screen and (max-width: 767px) {
            .rental-period-options {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 10px;
                margin: 12px 0;
            }

            .rental-period-option {
                width: 100%;
                min-width: unset;
            }

            .rental-details-row {
                flex-wrap: wrap;
                gap: 10px;
            }

            .rental-details-left,
            .rental-details-right,
            .quantity-selector {
                flex: 0 0 100%;
            }
        }

        .rental-accordion-header {
            background-color: #f8f8f8;
            padding: 10px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
            transition: background-color 0.3s ease;
        }

        .rental-accordion-header:hover {
            background-color: #f0f0f0;
        }

        .rental-accordion-header h3 {
            margin: 0;
            color: #000;
            font-size: 18px;
        }

        .accordion-icon {
            font-size: 12px;
            transition: transform 0.3s ease;
        }

        .rental-accordion-content {
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.3s ease-out;
            padding: 0 15px;
        }

        .rental-options-wrapper.active .rental-accordion-content {
            color: #222222;
            max-height: 1000px;
            padding: 15px;
        }

        .rental-options-wrapper.active .accordion-icon {
            transform: rotate(180deg);
        }

        .rental-options-wrapper h3 {
            color: #000;
            margin-top: 5px;
            margin-bottom: 5px;
            font-size: 18px;
        }

        .rental-period-option {
            flex: 1;
            border: 1px solid #e0e0e0;
            border-radius: 4px;
            padding: 8px 4px;
            cursor: pointer;
            text-align: center;
            font-size: 13px;
            min-width: 70px;
        }

        .rental-period-option:hover,
        .rental-period-option.active {
            border-color: #be2c3f;
            background-color: #fff9f9;
        }

        .rental-period-header {
            display: flex;
            flex-direction: column;
            font-size: 14px;
        }

        .rental-details-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
        }

        .rental-details-left,
        .rental-details-right {
            font-size: 18px;
        }

        .selected-rental {
            font-weight: 700;
        }

        .rental-total {
            font-weight: bold;
            color: #000;
            text-align: right;
        }

        .rental-total span {
            font-size: 1.2em;
        }

        .quantity-selector {
            display: flex;
            align-items: center;
        }

        .quantity-selector label {
            margin-right: 10px;
        }

        .quantity-input {
            display: flex;
            align-items: center;
            border: 1px solid #e0e0e0;
            border-radius: 3px;
        }

        .quantity-input button {
            background: none;
            border: none;
            padding: 5px 10px;
            cursor: pointer;
            font-size: 16px;
        }

        .quantity-input input {
            width: 40px;
            text-align: center;
            border: none;
            -moz-appearance: textfield;
        }

        .quantity-input input::-webkit-outer-spin-button,
        .quantity-input input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        .rental-actions {
            display: flex;
            justify-content: flex-end;
            margin-bottom: 10px;
        }

        #add-rental-to-cart {
            background-color: #be2c3f;
            color: white;
            border: none !important;
            padding: 10px 20px;
            border-radius: 5px !important;
            cursor: pointer;
            transition: background-color 0.3s ease;
            font-size: 16px;
            text-transform: uppercase;
        }

        #add-rental-to-cart:hover {
            background-color: #b71c1c;
        }

        .rental-faqs-link {
            display: block;
            text-align: right;
            color: #666;
            text-decoration: underline;
            font-size: 14px;
        }
        
        .cart-popup {
            position: fixed;
            top: 100px;
            left: 50%;
            transform: translate(-50%, -50%);
            background: #ffffff;
            padding: 25px;
            border-radius: 8px;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
            max-width: 500px;
            width: 90%;
            z-index: 9999;
            opacity: 1;
            transition: opacity 0.3s ease;
        }

        .cart-popup--hidden {
            opacity: 0;
            pointer-events: none;
        }

        .cart-popup h3 {
            margin: 0 0 20px;
            color: #333;
            font-size: 1.2em;
        }

        .rental-details {
            margin: 15px 0;
        }

        .rental-details p {
            margin: 8px 0;
            font-size: 0.95em;
            color: #444;
        }

        .cart-popup__close {
            position: absolute;
            right: 15px;
            top: 15px;
            background: none;
            border: none;
            font-size: 24px;
            cursor: pointer;
            padding: 5px;
            line-height: 1;
        }

        .button-group {
            display: flex;
            gap: 15px;
            margin-top: 20px;
        }

        .btn {
            flex: 1;
            padding: 12px 20px;
            border-radius: 4px;
            font-size: 14px;
            font-weight: 500;
            text-align: center;
            text-decoration: none;
            cursor: pointer;
            border: 1px solid transparent;
            min-width: 120px;
        }

        .btn--secondary {
            background-color: #f5f5f5;
            color: #333;
            border: 1px solid #ddd;
        }

        .btn--primary {
            background-color: #be2c3f;
            color: white;
        }

        @media screen and (max-width: 480px) {
            .button-group {
                flex-direction: column;
            }
            
            .btn {
                width: 100%;
            }
            
            .cart-popup {
                padding: 20px;
                margin: 10px;
            }
        }

        .cart-popup-item {
            display: flex;
            gap: 20px;
            padding: 15px 0;
        }

        .cart-popup-item__image-container {
            flex-shrink: 0;
            width: 100px;
            height: 100px;
            border: 1px solid #e0e0e0;
            border-radius: 4px;
            overflow: hidden;
        }

        .cart-popup-item__image {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }

        .cart-popup-item__description {
            flex: 1;
        }

        @media screen and (max-width: 480px) {
            .cart-popup-item {
                flex-direction: column;
                align-items: center;
                text-align: center;
            }

            .cart-popup-item__image-container {
                margin-bottom: 15px;
            }
        }

        .zip-code-input-wrapper {
            display: flex;
            gap: 8px;
            align-items: center;
            margin-top: 8px;
        }

        #zip-code-input {
            width: 120px;
            height: 45px;
            padding: 8px;
            border: 1px solid #e0e0e0;
            border-radius: 4px;
            font-size: 14px;
            text-align: center;
        }

        #validate-zip-code-button {
            background-color: #be2c3f;
            color: white;
            border: none;
            padding: 8px 16px;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            height: 35px;
            transition: background-color 0.3s ease;
        }

        #validate-zip-code-button:hover {
            background-color: #b71c1c;
        }

        .zip-code-status {
            margin-top: 8px;
            font-size: 14px;
            min-height: 20px;
        }

        .rental-input {
            -moz-appearance: textfield;
        }

        .rental-input::-webkit-outer-spin-button,
        .rental-input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        .zip-and-actions-wrapper {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            gap: 20px;
            margin-top: 20px;
            padding: 15px;
            border-top: 1px solid #e0e0e0;
        }

        .zip-code-section {
            flex: 1;
            max-width: 50%;
        }

        .rental-actions {
            flex: 1;
            max-width: 50%;
            display: flex;
            justify-content: flex-end;
        }

        .zip-code-input-wrapper {
            display: flex;
            gap: 10px;
            margin-bottom: 5px;
        }

        .rental-input {
            flex: 1;
            padding: 8px 12px;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 14px;
            min-width: 120px;
        }

        .rental-button {
            padding: 8px 15px;
            background-color: #f5f5f5;
            border: 1px solid #ddd;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            white-space: nowrap;
        }

        .zip-code-status {
            font-size: 13px;
            margin-top: 5px;
        }

        #add-rental-to-cart {
            width: 100%;
            max-width: 200px;
        }

        @media screen and (max-width: 480px) {
            .zip-and-actions-wrapper {
                flex-direction: column;
                gap: 15px;
            }

            .zip-code-section,
            .rental-actions {
                max-width: 100%;
            }

            #add-rental-to-cart {
                max-width: 100%;
            }
        }

        .rental-bottom-row {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
            margin-top: 20px;
            padding: 20px;
            background: #f9f9f9;
            border-radius: 4px;
        }

        .rental-bottom-left {
            flex: 0 0 60%;
            padding-right: 20px;
        }

        .rental-bottom-right {
            flex: 0 0 40%;
            text-align: right;
        }

        .zip-input-group {
            display: flex;
            gap: 10px;
            align-items: center;
        }

        .zip-input-group input {
            flex: 1;
            min-width: 120px;
            height: 40px;
            padding: 8px 12px;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 14px;
        }

        .zip-input-group button {
            height: 40px;
            padding: 8px 20px;
            background: #ffffff;
            border: 1px solid #ddd;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            white-space: nowrap;
            transition: all 0.2s ease;
        }

        #zip-code-status {
            margin-top: 8px;
            font-size: 13px;
            line-height: 1.4;
        }

        #add-rental-to-cart {
            width: 100%;
            height: 40px;
            max-width: 200px;
            font-size: 14px;
            font-weight: 500;
        }

        @media (max-width: 768px) {
            .rental-bottom-row {
                flex-direction: column;
                gap: 20px;
                padding: 15px;
            }
            
            .rental-bottom-left {
                flex: 0 0 100%;
                padding-right: 0;
            }
            
            .rental-bottom-right {
                flex: 0 0 100%;
                text-align: center;
            }
            
            #add-rental-to-cart {
                max-width: 100%;
            }
        }

        /* Skeleton Loader Styles */
        .rental-skeleton {
          background: #fff;
          padding: 20px;
          margin-bottom: 20px;
        }

        .skeleton-header {
          height: 32px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 4px;
          margin-bottom: 20px;
        }

        .skeleton-period {
          height: 45px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 4px;
          margin-bottom: 15px;
        }

        .skeleton-bottom {
          display: flex;
          gap: 20px;
        }

        .skeleton-input {
          flex: 2;
          height: 40px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 4px;
        }

        .skeleton-button {
          flex: 1;
          height: 40px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 4px;
        }

        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
    `;

    const styleElement = document.createElement('style');
    styleElement.textContent = styles;
    document.head.appendChild(styleElement);
  }

  async showAddToCartPopup(selectedData) {
    const popupWrapper = document.createElement('div');
    popupWrapper.className = 'cart-popup-wrapper cart-popup-wrapper--hidden';
    popupWrapper.setAttribute('role', 'dialog');
    popupWrapper.setAttribute('aria-modal', 'true');
    popupWrapper.setAttribute('data-cart-popup-wrapper', '');
  
    // Get quantity
    const quantity = parseInt(document.getElementById('rental-quantity')?.value || 1);
    
    // Calculate total amounts
    const totalRent = selectedData.total_rent * quantity;
    const deposit = selectedData.refundable_deposit * quantity;
    const monthlyRent = selectedData.emi;
    
    // Get product image using the same method as rental-cart.js
    const imageUrl = await this.getProductImageByVariant(this.variantId);


    // Format rental period
    const rentalPeriod = selectedData.rental_period.replace('m', ' Months');
  
    popupWrapper.innerHTML = `
      <div class="cart-popup" data-cart-popup tabindex="-1">
        <button class="cart-popup__close" aria-label="Close" data-cart-popup-close>
          <span aria-hidden="true">&#215;</span>
        </button>
        <div class="cart-popup-item">
          <div class="cart-popup-item__image-container">
            <img 
              src="${imageUrl || 'https://via.placeholder.com/100'}" 
              alt="Product image"
              class="cart-popup-item__image"
              onerror="this.onerror=null; this.src='https://via.placeholder.com/100';"
            >
          </div>
          <div class="cart-popup-item__description">
            <h3>Item Added to Rental Cart</h3>
            <div class="rental-details">
              <p><strong>Rental Period:</strong> ${rentalPeriod}</p>
              <p><strong>Monthly Rent:</strong> ${this.formatMoney(monthlyRent)}</p>
              <p><strong>Total Rent:</strong> ${this.formatMoney(totalRent)}</p>
              <p><strong>Refundable Deposit:</strong> ${this.formatMoney(deposit)}</p>
              <p><strong>Quantity:</strong> ${quantity}</p>
            </div>
          </div>
        </div>
        <div class="button-group">
          <button class="cart-popup__dismiss-button btn btn--secondary" data-cart-popup-dismiss>
            Continue Shopping
          </button>
          <a href="/pages/rental-cart" class="cart-popup__cta-link btn btn--primary">
            View Cart
          </a>
        </div>
      </div>
    `;
  
    // Update CSS
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      .cart-popup-wrapper {
        position: fixed;
        top: 100px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 9999;
        pointer-events: none;
        background: transparent;
      }
  
      .cart-popup {
        background: #ffffff;
        padding: 25px;
        border-radius: 8px;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
        max-width: 500px;
        width: 90%;
        position: relative;
        margin: 0;
        pointer-events: auto;
      }
  
      .cart-popup h3 {
        margin: 0 0 20px;
        color: #333;
        font-size: 1.2em;
      }
  
      .rental-details {
        margin: 15px 0;
      }
  
      .rental-details p {
        margin: 8px 0;
        font-size: 0.95em;
        color: #444;
      }
  
      .cart-popup__close {
        position: absolute;
        right: 15px;
        top: 15px;
        background: none;
        border: none;
        font-size: 24px;
        cursor: pointer;
        padding: 5px;
        line-height: 1;
      }
  
      .button-group {
        display: flex;
        gap: 15px;
        margin-top: 20px;
      }
  
      .btn {
        flex: 1;
        padding: 12px 20px;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        text-decoration: none;
        cursor: pointer;
        border: 1px solid transparent;
        min-width: 120px;
      }
  
      .btn--secondary {
        background-color: #f5f5f5;
        color: #333;
        border: 1px solid #ddd;
      }
  
      .btn--primary {
        background-color: #be2c3f;
        color: white;
      }
  
      @media screen and (max-width: 480px) {
        .button-group {
          flex-direction: column;
        }
        
        .btn {
          width: 100%;
        }
        
        .cart-popup {
          padding: 20px;
          margin: 10px;
        }
      }

      .cart-popup-item {
        display: flex;
        gap: 20px;
        padding: 15px 0;
      }

      .cart-popup-item__image-container {
        flex-shrink: 0;
        width: 100px;
        height: 100px;
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        overflow: hidden;
      }

      .cart-popup-item__image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }

      .cart-popup-item__description {
        flex: 1;
      }

      @media screen and (max-width: 480px) {
        .cart-popup-item {
          flex-direction: column;
          align-items: center;
          text-align: center;
        }

        .cart-popup-item__image-container {
          margin-bottom: 15px;
        }
      }
    `;
  
    document.head.appendChild(styleElement);
    document.body.appendChild(popupWrapper);
  
    // Setup event listeners
    const closeButton = popupWrapper.querySelector('[data-cart-popup-close]');
    const dismissButton = popupWrapper.querySelector('[data-cart-popup-dismiss]');
  
    const closePopup = () => {
      popupWrapper.classList.add('cart-popup-wrapper--hidden');
      setTimeout(() => popupWrapper.remove(), 50000);
    };
  
    closeButton.addEventListener('click', closePopup);
    dismissButton.addEventListener('click', closePopup);
  
    requestAnimationFrame(() => {
      popupWrapper.classList.remove('cart-popup-wrapper--hidden');
    });
  
    setTimeout(closePopup, 50000);
  }

  async getProductImageByVariant(variantId) {
    try {
        const response = await fetch(`${this.apiBaseUrl}/get-product-image/${variantId}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'include'
        });
        
        if (response.ok) {
            const data = await response.json();
            return data.image_url;
        }
        return null;
    } catch (error) {

        return null;
    }
  }

  // Method to validate ZIP code
  async validateZipCode() {
    const pinCode = document.getElementById('zip-code-input').value.trim();
    const zipCodeStatus = document.getElementById('zip-code-status');
    const validateButton = document.getElementById('validate-zip-code-button');
    const addToCartButton = document.getElementById('add-rental-to-cart');

    if (!pinCode) {
        zipCodeStatus.innerHTML = '<span style="color: #d32f2f;">Please enter a PIN code</span>';
        addToCartButton.disabled = true;
        addToCartButton.style.opacity = '0.5';
        addToCartButton.style.cursor = 'not-allowed';
        return;
    }

    validateButton.disabled = true;
    validateButton.textContent = 'Checking...';
    zipCodeStatus.innerHTML = '<span style="color: #666;">Validating PIN code...</span>';

    try {
        const response = await fetch(`${this.apiBaseUrl}/validate-zip-code/?pin_code=${encodeURIComponent(pinCode)}`);
        const data = await response.json();
        
        if (data.valid) {
            zipCodeStatus.innerHTML = `
                <span style="color: #2e7d32;">
                    ✓ Delivery available at your location
                </span>
            `;
            addToCartButton.disabled = false;
            addToCartButton.style.opacity = '1';
            addToCartButton.style.cursor = 'pointer';
        } else {
            zipCodeStatus.innerHTML = `
                <span style="color: #d32f2f;">
                    ✗ ${data.message || 'Delivery not available for this location'}
                </span>
            `;
            addToCartButton.disabled = true;
            addToCartButton.style.opacity = '0.5';
            addToCartButton.style.cursor = 'not-allowed';
        }
    } catch (error) {

        zipCodeStatus.innerHTML = `
            <span style="color: #d32f2f;">
                ✗ Error checking PIN code. Please try again.
            </span>
        `;
        addToCartButton.disabled = true;
        addToCartButton.style.opacity = '0.5';
        addToCartButton.style.cursor = 'not-allowed';
    } finally {
        validateButton.disabled = false;
        validateButton.textContent = 'Check';
    }
  }

  showSkeleton() {
    if (!this.rentalPrices) return;
    
    const skeleton = `
      <div class="rental-skeleton">
        <div class="skeleton-header"></div>
        <div class="skeleton-period"></div>
        <div class="skeleton-period"></div>
        <div class="skeleton-bottom">
          <div class="skeleton-input"></div>
          <div class="skeleton-button"></div>
        </div>
      </div>
    `;
    
    this.rentalPrices.innerHTML = skeleton;
  }
}

function initializeProductRental() {

  ProductRental.initialize();
}

document.addEventListener('DOMContentLoaded', initializeProductRental);